/**
 * @generated SignedSource<<b975e9d2d5b08b55c4006da5a8b1f1a3>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TeamDefaultTodoCategory_TodoCategoryTeam$data = {
  readonly allTodos: {
    readonly totalCount: number;
  };
  readonly category: {
    readonly id: string;
    readonly title: string;
  };
  readonly id: string;
  readonly notResolvedCount: number;
  readonly team: {
    readonly color: string | null;
    readonly id: string;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"TeamDefaultTodoCategory_TodoCategoryTeamPager">;
  readonly " $fragmentType": "TeamDefaultTodoCategory_TodoCategoryTeam";
};
export type TeamDefaultTodoCategory_TodoCategoryTeam$key = {
  readonly " $data"?: TeamDefaultTodoCategory_TodoCategoryTeam$data;
  readonly " $fragmentSpreads": FragmentRefs<"TeamDefaultTodoCategory_TodoCategoryTeam">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TeamDefaultTodoCategory_TodoCategoryTeam",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "notResolvedCount",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Team",
      "kind": "LinkedField",
      "name": "team",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "color",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "TodoCategory",
      "kind": "LinkedField",
      "name": "category",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "title",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": "allTodos",
      "args": null,
      "concreteType": "TodoConnection",
      "kind": "LinkedField",
      "name": "todos",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "totalCount",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TeamDefaultTodoCategory_TodoCategoryTeamPager"
    }
  ],
  "type": "TodoCategoryTeam",
  "abstractKey": null
};
})();

(node as any).hash = "88e5a0c8b033221c3042896189a42b88";

export default node;
